import React from "react";
import { useDispatch } from "react-redux";

import t from "../../../../Common/utils/translation/translator";

import AxisSelectionFilterCheckboxesFiltersSection from "./AxisSelectionFilterCheckboxesFiltersSection";

const AxisSelectionFilterAxisTypeSection = ({
  cartesianFilters,
  dependencies,
  isLoadingOrFetchingGetAxesCombinations,
  setCartesianFilters
}) => {
  const dispatch = useDispatch();

  const handleCoverStripChange = (event) => {
    const isChecked = event.target.checked;

    const updatedApplicationDataFilter = {
      ...cartesianFilters.applicationDataFilter,
      withCoverstrip: isChecked
    };

    dispatch(
      setCartesianFilters({
        ...cartesianFilters,
        applicationDataFilter: updatedApplicationDataFilter
      })
    );
  };

  const handleAntistaticBeltChange = (event) => {
    const isChecked = event.target.checked;

    const updatedApplicationDataFilter = {
      ...cartesianFilters.applicationDataFilter,
      withAntistaticBelt: isChecked
    };

    const updatedMechanicalDriveFilter = {
      ...cartesianFilters.mechanicalDriveFilter,
      functionAvailable: isChecked ? ["anti-static toothed belt"] : [null, "standard"]
    };
    dispatch(
      setCartesianFilters({
        ...cartesianFilters,
        mechanicalDriveFilter: updatedMechanicalDriveFilter,
        applicationDataFilter: updatedApplicationDataFilter
      })
    );
  };

  const handleIncreasedCorrosionProtectionChange = (event) => {
    const isChecked = event.target.checked;

    const updatedApplicationDataFilter = {
      ...cartesianFilters.applicationDataFilter,
      withIncreasedCorrosionProtection: isChecked
    };

    const updatedGuideFilter = {
      ...cartesianFilters.guideFilter,
      functionAvailable: isChecked ? ["increased corrosion resistance"] : [null, "standard"]
    };
    dispatch(
      setCartesianFilters({
        ...cartesianFilters,
        guideFilter: updatedGuideFilter,
        applicationDataFilter: updatedApplicationDataFilter
      })
    );
  };

  const handleDrivenAxisChange = () => {
    const updatedApplicationDataFilter = {
      ...cartesianFilters.applicationDataFilter,
      withDrivenAxis: true,
      withSupportAxis: false
    };

    const updatedAxisFilter = {
      ...cartesianFilters.axisFilter,
      functionAvailable: ["driven axis"]
    };
    dispatch(
      setCartesianFilters({
        ...cartesianFilters,
        axisFilter: updatedAxisFilter,
        applicationDataFilter: updatedApplicationDataFilter
      })
    );
  };

  const handleSupportAxisChange = () => {
    const updatedApplicationDataFilter = {
      ...cartesianFilters.applicationDataFilter,
      withDrivenAxis: false,
      withSupportAxis: true
    };

    const updatedAxisFilter = {
      ...cartesianFilters.axisFilter,
      functionAvailable: ["support axis"]
    };
    dispatch(
      setCartesianFilters({
        ...cartesianFilters,
        axisFilter: updatedAxisFilter,
        applicationDataFilter: updatedApplicationDataFilter
      })
    );
  };

  return (
    <div className="flex flex-col space-y-4">
      <span className="font-semibold text-gray-700 mb-2">{t("cartesian.ui.axis_selection.axis_type")}</span>
      <div className="flex">
        <qds-button
          importance={cartesianFilters?.applicationDataFilter?.withDrivenAxis ? "emphasized" : ""}
          text={t("cartesian.ui.axis_selection.driven_axis")}
          onClick={handleDrivenAxisChange}
        />
        <qds-button
          importance={cartesianFilters?.applicationDataFilter?.withSupportAxis ? "emphasized" : ""}
          text={t("cartesian.ui.axis_selection.support_axis")}
          onClick={handleSupportAxisChange}
        />
      </div>
      <div className="flex flex-col space-y-5">
        <AxisSelectionFilterCheckboxesFiltersSection
          cartesianFilters={cartesianFilters}
          handleCoverStripChange={handleCoverStripChange}
          handleAntistaticBeltChange={handleAntistaticBeltChange}
          handleIncreasedCorrosionProtectionChange={handleIncreasedCorrosionProtectionChange}
          isLoadingOrFetchingGetAxesCombinations={isLoadingOrFetchingGetAxesCombinations}
          dependencies={dependencies}
        />
      </div>
    </div>
  );
};

export default AxisSelectionFilterAxisTypeSection;
